// Import statements must come first
import { authApi } from './authApi';
import { eventsApi } from './eventsApi';
import { customersApi } from './customersApi';
import { venuesApi } from './venuesApi';
import { favoritesApi } from './favoritesApi';
import { ticketsApi } from './ticketsApi';
import { paymentsApi } from './paymentsApi';
import { adminAccountsApi, masterUsersApi } from './adminAccountsApi';

// Export all API modules
export * from './client';
export * from './authApi';
export * from './eventsApi';
export * from './customersApi';
export * from './venuesApi';
export * from './favoritesApi';
export * from './ticketsApi';
export * from './paymentsApi';
export * from './adminAccountsApi';

export const api = {
  auth: authApi,
  events: eventsApi,
  customers: customersApi,
  venues: venuesApi,
  favorites: favoritesApi,
  tickets: ticketsApi,
  payments: paymentsApi,
  adminAccounts: adminAccountsApi,
  masterUsers: masterUsersApi,
};

export default api;

